import {
  PhoneNumberFormat,
  PhoneNumberType,
  PhoneNumberUtil,
} from "google-libphonenumber";

export interface ValidatedMobileNumber {
  original: string;
  isValid: boolean;
  isValidMobileNumber: boolean;
  formatted: string;
  mobileId: string;
}

export const cleanMobileNumber = (
  phone: string,
  countryCode?: string,
): ValidatedMobileNumber => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const number = phoneUtil.parse(phone, countryCode);
    return {
      original: phone,
      isValid: phoneUtil.isValidNumber(number),
      isValidMobileNumber:
        phoneUtil.isValidNumber(number) &&
        (phoneUtil.getNumberType(number) === PhoneNumberType.MOBILE ||
          phoneUtil.getNumberType(number) ===
            PhoneNumberType.FIXED_LINE_OR_MOBILE),
      formatted: phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL),
      mobileId: phoneUtil.format(number, PhoneNumberFormat.E164),
    };
  } catch (e) {
    return {
      original: phone,
      isValid: false,
      isValidMobileNumber: false,
      formatted: phone,
      mobileId: getMobileId(phone),
    };
  }
};

export const getMobileId = (mobile: string) => {
  // Remove all non-numerical characters using regular expression
  // Returns in PhoneNumberFormat.E16 eg: +1234567890
  const cleanInput = mobile.replace(/[^0-9]/g, "");
  // Ensure the cleanInput starts with '+'
  if (!cleanInput.startsWith("+")) {
    return `+${cleanInput}`;
  }
  return cleanInput;
};
